<template>
  <div>
    <modalcart v-model="dialog" />
    <v-snackbar
      v-model="alert.show"
      timeout="2000"
      right
      top
      :color="alertColor"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-app-bar flat app height="90" light class="header-frame bg-hwi-3">
      <div class="pr-3" id="brand-bar">
        <router-link to="/seller/dashboard" class="d-none d-sm-block d-xs-none">
          <v-img
            contain
            class="img-logo fill-height"
            src="/assets/icons/logo-hwi.png"
            height="60"
            max-width="auto"
            width="150"
            light
            position="left center"
          ></v-img>
        </router-link>
        <router-link to="/seller/dashboard" class="d-flex align-center d-sm-none d-xs-flex small-logo">
          <v-img
            class="img-logo"
            width="36"
            src="/assets/icons/logo-gram-hwi-green.png"
          ></v-img>
        </router-link>
        <div class="dividers"></div>
        <div class="seller-headtitle">{{ seller_title }}</div>
      </div>

      <div id="feature-bar" class="seller-features" v-if="sellerData">
        <v-menu
          dark
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
          class="d-none d-sm-block d-xs-none"
          content-class="user-menu-content"
          id="user-bar"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              text
              v-bind="attrs"
              v-on="on"
              class="mt-md-n2 px-0 bg-transparent"
              id="userbtn-bar"
              elevation="0"
            >
              <div class="font-weight-bold">
                <span class="d-none d-sm-block d-xs-none pl-2">{{ sellerData ? sellerData.store_name : "" }}</span>
                <div class="d-block d-sm-none d-xs-block">
                  <v-img
                    width="24"
                    src="/assets/icons/user-no-pading.svg"
                  ></v-img>
                </div>
              </div>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dark color="white" id="user-menu" class="pb-5">
            <v-list-item link @click.native="gotoProfile" v-if="false">
              <v-icon class="pr-3 grey--text text--darken-1"
                >mdi-account</v-icon
              >
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Profil</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item link @click.native="gotoMyStore" v-if="['seller', 'stockist'].includes(sellerData.user_type)">
              <span class="pr-2 ml-n1">
                <v-img width="32" src="/assets/icons/icon-toko.svg"></v-img>
              </span
              >
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                >Toko Saya</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item link @click.native="gotoTransaction" v-if="false">
              <v-icon class="pr-3 grey--text text--darken-1"
                >mdi-format-list-bulleted</v-icon
              >
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-1"
                  >Transaksi</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click.native="onLogout">
              <v-icon class="pr-3 grey--text text--darken-1"
                >mdi-exit-to-app</v-icon
              >
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Logout</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          dark
          left
          open-on-hover
          offset-y
          class="d-block pb-5"
          content-class="menuseller-menu-content"
          id="menuseller-bar"
          :close-on-content-click="true"
          :close-on-click="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              fab x-small
              v-bind="attrs"
              v-on="on"
              class="mt-md-n2 px-0 bg-transparent"
              id="sellerbtn-bar"
              elevation="0"
              @click="toggleMenu"
            >
              <v-img width="20" src="/assets/seller/menu.svg"></v-img>
            </v-btn>
          </template>

          <v-list dark color="white" class="seller-feature-item" v-if="!isMobile">
            <template>
              <v-list-item v-for="(item, idx) in features" :key="idx" link @click.native="gotoFeature(item.to)">
                <v-img width="50" :src="item.icon"></v-img>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>

          <v-list dark color="white" class="seller-feature-item" v-else>
            <template v-for="(item, idx) in items">
              <template v-if="item.children.length === 0">
                <v-list-item :key="idx" link @click.native="gotoFeature(item.to)" class="d-flex flex-row align-center pl-0 ml-0" style="width: 100%;">
                  <v-img width="40px" height="40px" max-width="40px" contain class="mr-4" :src="item.icon"></v-img>
                  <v-list-item-content class="">
                    <v-list-item-title class="d-flex align-center justify-start black--text text--darken-2">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <template v-else>
                <template v-for="(sub, ids) in item.children">
                  <v-list-item :key="idx + '_' + ids" link @click.native="gotoFeature(sub.to)" class="d-flex flex-row align-center pl-0 ml-0" style="width: 100%;" v-if="item.access.includes('general') || item.access.includes(userType)">
                    <v-img width="40px" height="40px" max-width="40px" contain class="mr-4" :src="item.icon"></v-img>
                    <v-list-item-content class="">
                      <v-list-item-title class="d-flex align-center justify-start black--text text--darken-2">{{ sub.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </template>
            </template>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  components: {},
  data() {
    return {
      drawer: false,
      searchDrawer: false,
      dialog: false,
      isMobile: false,
      seller_title: '',
      userType: '',
      features: [
        {
          to: '/seller/produk-saya',
          icon: '/assets/seller/header/produk-saya-icon.svg',
          title: 'Produk Saya'
        },
        {
          to: '/seller/pesanan-saya',
          icon: '/assets/seller/header/pesanan-saya-icon.svg',
          title: 'Pesanan Saya'
        },
        // {
        //   to: '/seller/produk-eksklusif',
        //   icon: '/assets/seller/header/produk-eksklusif-icon.svg',
        //   title: 'Produk Eksklusif'
        // },
        // {
        //   to: '/seller/pembelian',
        //   icon: '/assets/seller/header/order-icon.svg',
        //   title: 'Pembelian Produk'
        // },
        {
          to: '/seller/saldo',
          icon: '/assets/seller/header/penghasilan-saya-icon.svg',
          title: 'Saldo Saya'
        },
        {
          to: '/seller/pengaturan-pengiriman',
          icon: '/assets/seller/header/pengiriman-saya-icon.svg',
          title: 'Pengaturan Pengiriman'
        },
        // {
        //   to: 'saldo-saya',
        //   icon: '/assets/seller/header/saldo-saya-icon.svg',
        //   title: 'Saldo Saya'
        // },
        {
          to: '/seller/profile-toko',
          icon: '/assets/seller/header/pengaturan-dasar-icon.svg',
          title: 'Pengaturan Toko'
        }
      ],
      items: [
        {
          icon: '/assets/seller/dashboard.svg',
          title: 'Dashboard',
          to: '/seller/dashboard',
          access: ['general'],
          children: []
        },
        {
          icon: '/assets/seller/pesanan.svg',
          title: 'Pesanan',
          to: '/seller/pesanan-saya',
          access: ['general', 'seller'],
          children: []
        },
        {
          icon: '/assets/seller/pesanan.svg',
          title: 'Pesanan Dropship',
          to: '/seller/pesanan-dropship',
          access: ['dropshipper', 'seller'],
          children: [
            {
              title: 'Pesanan Dropship',
              to: '/seller/pesanan-dropship',
              show: true,
            },
          ]
        },
        {
          icon: '/assets/seller/pesanan.svg',
          title: 'Pesanan Dropshipper',
          to: '/seller/pesanan-dropshipper',
          access: ['dropship'],
          children: [
            {
              title: 'Pesanan Dropshipper',
              to: '/seller/pesanan-dropshipper',
              show: true,
            },
          ]
        },
        {
          icon: '/assets/seller/produk.svg',
          title: 'Produk',
          to: '/seller',
          access: ['general'],
          children: [
            {
              title: 'Produk Saya',
              to: '/seller/produk-saya',
              show: true,
            },
            {
              title: 'Tambah Produk Baru',
              to: '/seller/tambah-produk',
              show: true,
            }
          ]
        },
        {
          icon: '/assets/seller/stokis.svg',
          title: 'Dropship Saya',
          to: '/seller',
          access: ['dropshipper', 'seller'],
          children: [
            {
              title: 'Daftar Dropship',
              to: '/seller/list-dropship',
              show: true,
            },
            {
              title: 'Tambah Dropship Baru',
              to: '/seller/tambah-dropship',
              show: true,
            },
          ]
        },
        {
          icon: '/assets/seller/stokis.svg',
          title: 'Dropshipper Saya',
          to: '/seller',
          access: ['dropship'],
          children: [
            {
              title: 'Daftar Dropshipper',
              to: '/seller/list-dropshipper',
              show: true,
            },
          ]
        },
        {
          icon: '/assets/seller/penghasilanmu.svg',
          title: 'Saldo',
          to: '/seller/saldo',
          access: ['general'],
          children: []
        },
        {
          icon: '/assets/seller/pengaturan.svg',
          title: 'Pengaturan',
          to: '/seller',
          access: ['general'],
          children: [
            {
              title: 'Profil Toko',
              to: '/seller/profile-toko',
              show: true,
            },
            {
              title: 'Jasa Pengiriman',
              to: '/seller/pengaturan-pengiriman',
              show: true,
            },
          ]
        }
      ]
    };
  },
  watch: {
		detailStore(newData) {
			if (newData) {
        let params = this.sellerData
        params.store_is_dropship = newData.store_is_dropship
        params.store_is_dropshipper = newData.store_is_dropshipper
        params.store_is_seller = newData.store_is_seller
        params.store_free_delivery = newData.store_free_delivery

				this.refreshData(params)
			}
		},

    sellerData(val) {
      if (val) {
        if (val.store_is_dropshipper == 'Ya') {
        if (val.store_is_seller == 'Ya') this.seller_title = 'Seller & Dropshipper' 
        else if (val.store_is_seller == 'Tidak' && val.store_is_dropship == 'Tidak') this.seller_title = 'Dropshipper' 
        else this.seller_title = 'Dropshipper' 

        if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Tidak' && val.store_is_seller == 'Ya') this.userType = 'seller'
				else if (val.store_is_dropshipper == 'Ya' && val.store_is_dropship == 'Tidak') this.userType = 'dropshipper'
				else if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Ya') this.userType = 'dropship'
				else this.userType = 'seller'
      }
      else if (val.store_is_dropship == 'Ya') {
        if (val.store_is_seller == 'Ya') this.seller_title = 'Stockist Dropship & Seller' 
        else this.seller_title = 'Stockist Dropship'
      }
      else this.seller_title = 'Seller'
      }
    }
	},
  computed: {
    ...mapState('authSeller', ['isAuth', 'sellerData']),
    ...mapState('storeSeller', ['detailStore']),
    ...mapState(['alert']),

    alertColor() {
      switch (this.alert.type) {
        case 'success':
        return 'success';
        case 'warning':
        return 'yellow';
        default:
        return 'red';
      }
    },

		windowWidth() {
      return this.getWindowWidth()
		}
  },
  methods: {
    ...mapActions('authSeller', ['logout', 'refreshData']),
    ...mapMutations(['hideAlert']),

    toggleMenu() {
      if (document.body.classList.contains('hideMenu')) {
        document.body.classList.remove('hideMenu')
        document.body.classList.add('openMenu')
      } else {
        document.body.classList.remove('openMenu')
        document.body.classList.add('hideMenu')
      }
    },

    getWindowWidth() {
      let screen = document.documentElement.clientWidth
      if (screen <= 600) this.isMobile = true
      else this.isMobile = false
		},
    wdrawer() {
      if (window.matchMedia("(min-width: 600px)").matches) {
        this.drawer = false;
      }
    },
    gotoFeature(link) {
      // this.$router.push(link)
      window.location.replace(window.location.origin + link);
    },
    gotoProfile() {
      this.$router.push({
        name: "profile",
      });
    },
    gotoTransaction() {
      // this.$router.push("/seller/transaction").catch(() => {});
      window.location.replace(window.location.origin + '/seller/transaction');
    },
    gotoMyStore() {
      // let routeData = this.$router.resolve({name:"seller-dashboard"})
      let routeData = window.location.origin + '/seller/dashboard'
      window.open(routeData.href, '_blank');
    },
    onLogout() {
      this.logout().then(() => {
        if (this.$route.name && this.$route.name != "home") {
          this.$router.push({
            name: "home",
          });
        }
      });
    },
    cari() {
      if (this.search_text) {
        this.$router.push({
          name: "search-product",
          params: {
            search: this.search_text,
          },
        });
      }
    },
    clearSearch() {
      this.searchDrawer = false;
    },
  },
  created() {
    document.body.classList.add('hideMenu')
    this.getWindowWidth()
    window.addEventListener('resize', this.getWindowWidth)

    if (this.sellerData.store_is_dropshipper == 'Ya') {
      if (this.sellerData.store_is_seller == 'Ya') this.seller_title = 'Seller & Dropshipper' 
      else if (this.sellerData.store_is_seller == 'Tidak' && this.sellerData.store_is_dropship == 'Tidak') this.seller_title = 'Dropshipper' 
      else this.seller_title = 'Dropshipper' 
    }
    else if (this.sellerData.store_is_dropship == 'Ya') {
      if (this.sellerData.store_is_seller == 'Ya') this.seller_title = 'Stockist Dropship & Seller' 
      else this.seller_title = 'Stockist Dropship'
    }
    else this.seller_title = 'Seller'

    if (this.sellerData && Object.keys(this.sellerData).length > 0) {
			const val = this.sellerData
			if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Tidak' && val.store_is_seller == 'Ya') this.userType = 'seller'
			else if (val.store_is_dropshipper == 'Ya' && val.store_is_dropship == 'Tidak') this.userType = 'dropshipper'
			else if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Ya') this.userType = 'dropship'
			else this.userType = 'seller'
		}
  },
  destroyed() {
    window.addEventListener('resize', this.getWindowWidth)
    
  },
};
</script>

<style lang="scss" scoped>
#brand-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  .seller-headtitle {
    color: #fff;
    font-size: 20px;
    height: 23px;
    font-weight: bold;
  }
  .dividers {
    display: block;
    margin: 0 25px;
    width: 1px;
    background: #fff;
    height: 40px;
  }
}
#feature-bar {
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: auto;
  padding-left: 25px;
}

.small-logo {
  background: #fff;
  width: 40px;
  height: 40px;
  padding: 6px 8px;
  border-radius: 4px;

  .v-image {
    display: block;
    margin: 0 auto;
  }
}

#mini-search-bar {
  .v-image {
    .v-image__image {
      background-size: 20px !important;
    }
  }
}

@media (max-width: 599px) {
  #cart-bar,
  #message-bar,
  #seller-message-bar,
  #mini-search-bar {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }

  .header-frame {
    #brand-bar {
      .dividers { display: none; }
      .seller-headtitle {
        padding-left: 15px;
        font-size: 1rem;
        line-height: normal;
        height: 40px;
        display: flex;
        align-items: center;
      }
    }
  }

  .user-menu-content {
    width: 100% !important;
    height: 100% !important;
    left: 0px !important;
    top: 60px !important;
    height: 100% !important;
    max-width: 100% !important;
    padding-top: 15px!important;

    #user-menu {
      height: 100%;
      .v-list-item:hover {
        background: rgba(0,0,0,0.05);
      }
    }
  }

  .menuseller-menu-content {
    width: 100% !important;
    height: 100% !important;
    left: 0px !important;
    top: 60px !important;
    height: 100% !important;
    max-width: 100% !important;
    padding-top: 15px!important;
    overflow: hidden !important;
    box-shadow: none!important;

    .seller-feature-item {
      height: 90%;
      width: 100%;
      overflow-y: auto;
      padding-bottom: 4rem;
      .v-list-item {
        margin: 0 2% 0.5%;
      }
    }

    .seller-feature-item.mobile-item {
      height: 90vh;
      width: 100%;
      position: fixed;
      left: 0;
      overflow-y: auto;
      .v-list-item {
        flex: 1 0 100%;
        margin: 0 0% 4%;
        width: 100%;
        flex-direction: row;
        padding: 0!important;
        height: 50px;
        align-items: center;
        background: #e9e9e9;
        border-radius: 0!important;

        .v-image {
          width: 42px!important;
          height: 42px!important;
          flex: none;
          background: transparent;
          // background: #e5e5e5;

          .v-image__image {
            background-size: 90% auto !important;
            opacity: 1;
          }
        }

        .v-list-item__content {
          padding: 0;
          flex: auto;
          height: auto;
          padding-left: 5px;
          font-weight: bold;

          .v-list-item__title {
            height: auto;
            text-align: left;
          }
        }
      }
      
      .child-items {
        width: 100%;
        display: flex;
        .v-list-item-sub {
          align-items: center;
          .v-image {
            height: 50px;
            background: #0ea35c!important;
            border-radius: 100%!important;
            display: block;
            margin: 0 auto;
          }

          .text-subtitle-2 {
            line-height: normal;
            text-align: center;
          }
        }
      }
    }
  }

  #feature-bar {
    padding-left: 5px;
  }
}
</style>
